<ng-container *transloco="let t; read: 'reports'">
@if (reportData.length) {
  <!-- classroomName is server-supplied and is not translated here. -->
  <p class="mt-6">{{ reportData.length === 1
    ? t('activityBankResults.childSelected', { count: reportData.length, classroom: reportData[0].classroomName })
    : t('activityBankResults.childrenSelected', { count: reportData.length, classroom: reportData[0].classroomName }) }}
  </p>
}
@for (child of reportData; track child) {
  <div class="class-planning-report report-well" id="report" [ngClass]="{'report-2025': child.is2025}">
    <div class="flex items-center justify-between">
      <h1 [ngClass]="{ '!mb-0': selectedStudent !== child.enrollmentId }">{{ t('activityBankResults.childActivitiesTitle', { name: child.firstName }) }}</h1>
      <div>
        @if(selectedStudent === child.enrollmentId) {
          <drdp-btn (click)="onSave(child)" color="outline" class="mr-3"><i class="text-drdpblue-300 text-xl uil uil-save mr-1"></i>{{ 'common.save' | transloco }}</drdp-btn>
        }
        <i class="text-2xl ml-2 cursor-pointer" [ngClass]="{'uil uil-angle-down': selectedStudent !== child.enrollmentId,
          'uil uil-angle-right': selectedStudent === child.enrollmentId}" (click)="changeStudentShow(child.enrollmentId)">
        </i>
      </div>
    </div>
    @if (selectedStudent === child.enrollmentId) {
      <ul class="intro mt-4">
        <!-- The values inside <strong> are server-supplied and are not translated here. -->
        <li>{{ t('activityBankResults.childLabel') }} <strong>{{child.firstName}} {{child.lastName}}</strong></li>
        <li>{{ t('activityBankResults.classLabel') }} <strong>{{child.classroomName}}</strong></li>
        <li>{{ t('activityBankResults.ratingPeriodLabel') }} <strong>{{child.ratingPeriod}}</strong></li>
        <li>{{ t('activityBankResults.teacherLabel') }} <strong>{{child.teachers}}</strong></li>
      </ul>

      @for (domain of child.domains; track domain) {
        <div class="domain" [ngClass]="domain.domainCode.toLowerCase()">
          <h2 [ngClass]="'icon-' + domainClass(domain.domainCode)">{{domain.domainName}}</h2>

          <div class="table-container">
            <table class="rating-table data-table" style="width: unset !important;">
              <thead>
                <tr>
                  @for (measure of domain.measures; track measure) {
                    <th class="measure-cell">{{measure.measureCode}} {{measure.measureName}}</th>
                  }
                </tr>
              </thead>
              <tbody>
                <tr>
                  @for (measure of domain.measures; track measure) {
                    <td>
                      @if (measure.activities.length) {
                        @for (level of measure.levels; track level) {
                          <div class="text-center p-2 mb-1 font-bold" [ngClass]="level.levelCode.toLowerCase()">{{level.levelDescription}}</div>
                          @for (activity of measure.activities; track activity) {
                            @if (activity.activityBankId) {
                              <mat-checkbox class="flex activity font-medium !mt-1"
                                [(ngModel)]="activity.isSelected">
                                {{activity.activity}}
                              </mat-checkbox>
                            }
                            @else {
                              <div>{{ t('activities.notAvailable') }}</div>
                            }
                          }
                        }
                      }
                    </td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      }
    }
  </div>
}
</ng-container>
